import { useEffect, useMemo, useRef, useState } from "react";
import styles from "./MultiOTPSelection.module.scss";
import { BiLockOpenAlt } from "react-icons/bi";
import { MdMailOutline } from "react-icons/md";
import {
	EmailOtpSteps,
	IIntegrationPartner,
	integrationAuthFormFields,
	OtpDeliveryOptions,
} from "../../../interfaces/interfaces";
import { useAppDispatch } from "../../../redux/reduxHooks";
import { clearCrendentialVerificationDetails } from "../../../redux/credentialVerification/credentialVerification";
import { ipShortNames } from "./emailOtpHelper";
import MeritoButton from "../../../components/common/MeritoButtons/MeritoButtons";
import { FaMobileAlt } from "react-icons/fa";

type Props = {
	ip: IIntegrationPartner;
	setStep: Function;
	showFields?: Set<integrationAuthFormFields>;
	initialValues?: any;
	handleFormSubmit?: (value: any) => void;
	showHeader?: boolean;
};

const otpOptions = [
	{
		name: "No OTP",
		logo: (
			<>
				<BiLockOpenAlt />
			</>
		),
		value: OtpDeliveryOptions.NoOtp,
	},
	{
		name: (
			<div>
				OTP on
				<br />
				Email
			</div>
		),
		logo: (
			<>
				<MdMailOutline />
			</>
		),
		value: OtpDeliveryOptions.Email,
	},
	{
		name: (
			<div>
				OTP only on
				<br />
				Mobile
			</div>
		),
		logo: (
			<>
				<FaMobileAlt />
			</>
		),
		value: OtpDeliveryOptions.Mobile,
	},
];

export const setRPAValidationObj = () => {
	window.localStorage.setItem(
		"validatingRPAExpiry",
		String(new Date(new Date().getTime() + 5 * 60000).getTime())
	);
};

export const MultiOTPSelectionForm = ({
	ip,
	setStep,
	showFields,
	initialValues = null,
	showHeader = false,
	handleFormSubmit,
}: Props) => {
	const dispatch = useAppDispatch();
	const isFirstRender = useRef(true); // Flag to track first render
	const initialStates = {
		otpOption: "",
	};

	const [form, setForm] = useState(initialStates);

	useEffect(() => {
		if (initialValues) setForm(initialValues);
	}, [initialValues]);

	useEffect(() => {
		if (isFirstRender.current) {
			isFirstRender.current = false;
			return;
		}
		return () => {
			console.log("RUNNING CLEANUP FUNCTION");
			dispatch(clearCrendentialVerificationDetails());
		};
	}, []);

	const disableBtn = useMemo(() => {
		let otpOptionCheck = showFields?.has(integrationAuthFormFields.otpOption)
			? form?.otpOption?.length
			: true;

		return !otpOptionCheck;
	}, [form, showFields]);

	const handleChange = (e) => {
		const field = e.target.name;
		const value = e.target.name === "termsChecked" ? e.target.checked : e.target.value;
		var formObj = {
			...form,
			[field]: value,
		};
		console.log("formObj", formObj);
		setForm(formObj);
	};

	const handleSubmit = () => {
		console.log(`Submitting Form with details: `, form);

		// if (form.otpOption === OtpDeliveryOptions.Mobile) {
		// 	console.log("setting step", EmailOtpSteps.contactMeritoMobileOtp);
		// 	console.log("form", form);
		// 	// setStep(EmailOtpSteps.contactMeritoMobileOtp);
		// 	return;
		// }
		handleFormSubmit(form);
		// setStep(9);
	};

	const shortIpName = ipShortNames[ip?.name] ?? ip?.companyName;

	return (
		<div className={styles.otpSelectionRootContainer}>
			{showHeader ? (
				<div className={styles.headerContainer}>
					<div className={styles.ipLogoContainer}>
						<img src={ip?.logo} />
					</div>
					<div className={styles.headerText}>
						Do you get an OTP when
						<br />
						logging into <span>{shortIpName}</span>
					</div>
				</div>
			) : null}
			<div className={styles.container}>
				<div className={styles.field}>
					<div className={styles.otpOptionContainer}>
						{otpOptions.map((otpOption) => {
							return (
								<div
									className={`${styles.otpOption} ${form?.otpOption === otpOption.value ? styles.active : ""}`}
									onClick={() => {
										handleChange({
											target: {
												name: "otpOption",
												value: otpOption.value,
											},
										});
									}}
								>
									<div className={styles.iconContainer}>{otpOption.logo}</div>
									<div className={styles.titleContianer}>{otpOption.name}</div>
								</div>
							);
						})}
					</div>
				</div>
				<MeritoButton
					type="primary-1"
					size="md2"
					btnText={"Continue"}
					disabled={disableBtn}
					onClick={handleSubmit}
					extraStyles={{ width: "100%", borderRadius: "10rem" }}
				/>
			</div>
		</div>
	);
};
